import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { retry, catchError, map } from "rxjs/operators";
import { HttpDataService, ApiEnum } from "./http-data.service";
import { API_ENDPOINTS } from "../constants/api-endpoints.constants";

// Models
import { SiteSummaryViewModel } from "../models/master/site-summary.model";
import { CentrosProcedureViewModel } from "../models/master/centro.model";

@Injectable({
	providedIn: "root",
})
export class SiteService {
	constructor(private readonly httpDataService: HttpDataService) {}

	getPublic(): Observable<CentrosProcedureViewModel[]> {
		return this.httpDataService
			.get$<CentrosProcedureViewModel[]>(
				ApiEnum.API_ROOT,
				API_ENDPOINTS.centro.list()
			)
			.pipe(
				map((sites) => {
					return sites;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<
						CentrosProcedureViewModel[]
					>("getPublic")
				)
			);
	}

	findPublic(id: number): Observable<CentrosProcedureViewModel> {
		return this.httpDataService
			.get$<CentrosProcedureViewModel>(
				ApiEnum.API_ROOT,
				API_ENDPOINTS.centro.getById(id)
			)
			.pipe(
				map((site) => {
					return site;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CentrosProcedureViewModel>(
						"findPublic"
					)
				)
			);
	}

	getSummary(): Observable<SiteSummaryViewModel[]> {
		return this.httpDataService
			.get$<SiteSummaryViewModel[]>(
				ApiEnum.API_ROOT,
				API_ENDPOINTS.site.get()
			)
			.pipe(
				map((sites) => {
					return sites;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<SiteSummaryViewModel[]>(
						"get"
					)
				)
			);
	}

	find(code: string): Observable<CentrosProcedureViewModel> {
		return this.httpDataService
			.get$<CentrosProcedureViewModel>(
				ApiEnum.API_ROOT,
				API_ENDPOINTS.site.find(code)
			)
			.pipe(
				map((site) => {
					return site;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CentrosProcedureViewModel>(
						"find"
					)
				)
			);
	}

	getByServiceCode(
		serviceCode: string
	): Observable<CentrosProcedureViewModel[]> {
		return this.httpDataService
			.get$<CentrosProcedureViewModel[]>(
				ApiEnum.API_ROOT,
				API_ENDPOINTS.site.getByServiceCode(serviceCode),
				""
			)
			.pipe(
				map((sites) => {
					return sites;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<
						CentrosProcedureViewModel[]
					>("getByServiceCode")
				)
			);
	}
}
